import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import Input from 'jl-design-system/elements/input/Input';
//
import CircleLoader from '../../../circle-loader/CircleLoader';
import PROGRESS_STATE from '../../../../constants/progressStateConstants';
import styles from './input-with-loading.scss';


const { NONE, LOADING, FAILED, SUCCESS } = PROGRESS_STATE;

class InputWithProgress extends PureComponent {
  static propTypes = {
    ...Input.propTypes,
    inputElement: PropTypes.func,
    progress: PropTypes.oneOf([
      NONE,
      LOADING,
      FAILED,
      SUCCESS,
    ]),
  };

  static defaultProps = {
    ...Input.defaultProps,
    inputElement: null,
    progress: NONE,
  };

  render() {
    const { progress, inputElement, ...allOtherProps } = this.props;
    return (
      <div className={`${styles.root} ${progress !== PROGRESS_STATE.NONE && styles.padding}`}>
        {
          inputElement ? React.createElement(inputElement, { ...allOtherProps }) : <Input {...allOtherProps} />
        }
        <CircleLoader
          className={styles.spinner}
          progress={progress}
        />
      </div>
    );
  }
}

export default InputWithProgress;
